module.exports = __webpack_public_path__ + "static/media/idea_X_11.a0702387.webp";